import * as React from 'react';
import { IAddUserByLoyaltyCardFormProps } from './add-user-by-loyalty-card-form.props.autogenerated';
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
/* tslint:disable: no-duplicate-imports */

// tslint:disable-next-line: no-any
export interface ILoyaltyUserFormExtendedProps extends IAddUserByLoyaltyCardFormProps<any> {
    className?: string;
    captchaKey?: string;
    textBox: React.ReactNode;
}

/**
 *
 * Form component
 */
class LoyaltyCardForm extends React.Component<ILoyaltyUserFormExtendedProps> {
    constructor(props: ILoyaltyUserFormExtendedProps) {
        super(props);
    }

    public componentDidMount(): void {
        const script = document.createElement('script');
        script.src = 'https://www.google.com/recaptcha/api.js';
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
    }

    public render(): JSX.Element | null {
        const LoyaltyCardViewProps = {
            ...this.props
        };
        return this.props.renderView(LoyaltyCardViewProps);
    }
}

export default LoyaltyCardForm;
